import { render, staticRenderFns } from "./BusinessOmniplayEventsCore.vue?vue&type=template&id=67fc50e5"
import script from "./BusinessOmniplayEventsCore.vue?vue&type=script&lang=js"
export * from "./BusinessOmniplayEventsCore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports